module.exports = __webpack_public_path__ + "static/media/planSvg.84421182.svg";